<template>
  <div v-if="log || results.length">
    <MaxTable ref="MaxTable"></MaxTable>
    <Tabs type="card" v-model="sqlTab" @on-click="refreshExecuteLog" name="sqlResultTab">
      <TabPane label="执行记录" v-if="log" tab="sqlResultTab">
        <Table ref="executeLogTable" :loading="execLog.loading" :data="execLog.data" :columns="execLog.columns" size="small"/>
        <Row style="margin: 10px;">
          <div style="float: right;">
            <page :total="execLog.count" :current="execLog.page" :page-size="execLog.size" @on-change="getExecuteLog"></page>
          </div>
        </Row>
      </TabPane>
      <TabPane v-for="resTab in results" :key="resTab.id" :label="'结果' + resTab.id" tab="sqlResultTab">
        <Row>
          <Alert show-icon v-if="resTab.msg">{{ resTab.msg }}</Alert>
          <a v-on:click="fullTable(resTab, '结果' + resTab.id)" style="float: right">全屏</a>
        </Row>
        <Row>
          <Table ref="resTable" :height="resTab.res.length > 5 ? 300 : 0" :data="resTab.res" :columns="resTab.columns" size="small" />
        </Row>
      </TabPane>
    </Tabs>
  </div>
</template>

<script>
import { getExecuteLog } from '@/api/mysql'
import MaxTable from '@/view/components/modal/max-table'
export default {
  name: 'sqlResults',
  components: {
    MaxTable
  },
  props: {
    log: {
      type: Boolean,
      default: () => {
        return true
      }
    },
    callbackdata: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data () {
    return {
      sqlTab: 0,
      execLog: {
        data: [],
        columns: [
          {
            title: '时间',
            key: 'create_time',
            align: 'center',
            width: 165,
            render: (h, params) => {
              return h('div', new Date(params.row.create_time).toLocaleString())
            }
          },
          {title: '数据库', key: 'db', width: 150, align: 'center'},
          {title: 'SQL', key: 'sql', tooltip: true},
          {title: '执行时间(s)', key: 'execute_time', width: 150, align: 'center'},
          {title: '执行结果',
            key: 'is_failed',
            width: 120,
            render: (h, params) => {
              return h('div', params.row.is_failed ? '执行失败' : '执行成功')
            }
          }
        ],
        count: 0,
        page: 1,
        size: 5,
        loading: false
      },
      results: []
    }
  },
  mounted () {
    this.getExecuteLog()
  },
  methods: {
    // 刷新执行记录
    refreshExecuteLog (name) {
      this.sqlTab = name
      if (!name) {
        this.getExecuteLog()
      }
    },
    // 获取执行记录
    getExecuteLog (value = 1) {
      if (typeof value === 'number') {
        this.execLog.page = value
      }
      let params = {
        instance_id: this.callbackdata.instance_id,
        page: this.execLog.page,
        size: this.execLog.size,
        execute_user_id: this.$store.state.user.userId
      }
      this.execLog.loading = true
      getExecuteLog(params).then(res => {
        this.execLog.data = res.data.results
        this.execLog.count = res.data.count
        this.execLog.loading = false
      }).catch(res => {
        this.execLog.loading = false
        if (res.request) {
          this.$Notice.error({
            title: '获取数据列表失败！请求状态码:' + res.request.status,
            desc: res.request.responseText
          })
        } else {
          this.$Notice.error({
            title: '获取数据列表失败！服务器无响应'
          })
        }
      })
    },
    // 展示结果
    showResult (results) {
      this.results = results
      if (this.log) {
        this.sqlTab = 1
      } else {
        this.sqlTab = 0
      }
    },
    // 全屏查看表格
    fullTable (data, title) {
      this.$refs.MaxTable.showModal(data.res, data.columns, title)
    },
    // 导出
    exportData () {
      if (!this.sqlTab && this.log) {
        this.$refs.executeLogTable.exportCsv({
          filename: `executeLog-${(new Date()).valueOf()}.csv`
        })
      } else {
        this.$refs.resTable[this.log ? this.sqlTab - 1 : this.sqlTab].exportCsv({
          filename: `query-${(new Date()).valueOf()}.csv`
        })
      }
    }
  }
}
</script>

<style scoped>

</style>
